import axios from "axios";

axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";

const bonusApi = axios.create({
  baseURL: "https://kubernetes-external.nomin.mn:31324/loyalty-bonus-service/",
  // baseURL: "http://localhost:85/loyalty-bonus-service/",
});
const axiosApi = axios.create({
  // baseURL: "http://192.168.90.124:8083/Card/rest/",
  baseURL: "https://bonus.nomin.mn/restapi/Card/rest/",
});
const cardApi = axios.create({
  baseURL: "https://kubernetes-external.nomin.mn:31324/loyalty-bonus-service",
  // baseURL: "http://localhost:85/loyalty-bonus-service/",
});

const internalApi = axios.create({
  baseURL: "https://kubernetes-external.nomin.mn:31324/loyalty-bonus-service",
  // baseURL: "http://192.168.90.116:8084/loyalty-bonus-service/",
});

axios.defaults.timeout = 90000;

export default {
  install(app) {
    app.prototype.$axiosApi = axiosApi;
    app.prototype.$bonusApi = bonusApi;
    app.prototype.$cardApi = cardApi;
    app.prototype.$internalApi = internalApi;
  },
};

export { bonusApi, axiosApi, cardApi, internalApi };
